import * as React from 'react';
import { Drawer as DrawerPrimitive } from 'vaul';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const drawerTitleVariants = cva('rocco-drawer-title', {
    variants: {
        variant: {
            default: 'text-center text-xl text-foreground md:text-left',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const DrawerTitle = React.forwardRef<
    React.ElementRef<typeof DrawerPrimitive.Title>,
    React.ComponentPropsWithoutRef<typeof DrawerPrimitive.Title> &
        VariantProps<typeof drawerTitleVariants>
>(({ className, variant, ...props }, ref) => (
    <DrawerPrimitive.Title
        ref={ref}
        className={cn(drawerTitleVariants({ variant, className }))}
        {...props}
    />
));

DrawerTitle.displayName = DrawerPrimitive.Title.displayName;
